
// Do not edit directly
// Generated on Mon, 07 Apr 2025 22:29:11 GMT


export default {
  'common': {
    'white': '#f1f1f1', /* Primitives: A soft white shade. Reference token, not for direct usage. */
    'black': '#000000', /* Primitives: Pure black. Reference token, not for direct usage. */
    'transparent': 'rgba(0, 0, 0, 0)', /* Primitives: Fully transparent color. Reference token, not for direct usage. */
    'gray': '#424242', /* Primitives: A mid-tone gray. Reference token, not for direct usage. */
  },
  'orange': {
    '50': '#ffdfd1', /* Primitives: Light peach. Reference token, not for direct usage. */
    '100': '#ffa781', /* Primitives: Soft orange. Reference token, not for direct usage. */
    '200': '#ff7233', /* Primitives: Bold orange. Reference token, not for direct usage. */
    '300': '#ff4e00', /* Primitives: Intense orange. Reference token, not for direct usage. */
  },
  'blue': {
    '50': '#656b77', /* Primitives: Muted blue-gray. Reference token, not for direct usage. */
    '100': '#222b3c', /* Primitives: Dark navy blue. Reference token, not for direct usage. */
    '200': '#151b26', /* Primitives: Deep midnight blue. Reference token, not for direct usage. */
    '300': '#020a19', /* Primitives: Almost-black blue. Reference token, not for direct usage. */
  },
  'red': {
    '50': '#c25454', /* Primitives: Warm muted red. Reference token, not for direct usage. */
    '100': '#ff5e5b', /* Primitives: Bright coral red. Reference token, not for direct usage. */
    '200': '#e11341', /* Primitives: Vivid crimson red. Reference token, not for direct usage. */
    '300': '#6f0707', /* Primitives: Dark maroon. Reference token, not for direct usage. */
  },
  'green': {
    '50': '#b7eaae', /* Primitives: Light green. Reference token, not for direct usage. */
    '100': '#5bffb0', /* Primitives: Bright mint. Reference token, not for direct usage. */
    '200': '#4bcb34', /* Primitives: Fresh grass. Reference token, not for direct usage. */
    '300': '#10a82c', /* Primitives: Dark forest green. Reference token, not for direct usage. */
  },
  'base': {
    'primary': '#151b26', /* Reference Token: color.blue.200 */
    'secondary': '#222b3c', /* Reference Token: color.blue.100 */
    'tertiary': '#656b77', /* Reference Token: color.blue.50 */
    'black': '#000000', /* Reference Token: color.common.black */
    'white': '#f1f1f1', /* Reference Token: color.common.white */
    'white-20': 'rgba(241, 241, 241, 0.2)', /* Reference Token: color.common.white. Alpha Value: 20% */
    'gray': 'rgba(66, 66, 66, 0.5)', /* Reference Token: color.common.gray. Alpha Value: 50% */
  },
  'fills': {
    'primary': 'rgba(21, 27, 38, 0.88)', /* Reference Token: color.blue.200. Alpha Value: 88% */
    'secondary': 'rgba(21, 27, 38, 0.78)', /* Reference Token: color.blue.200. Alpha Value: 78% */
    'tertiary': 'rgba(241, 241, 241, 0.15)', /* Reference Token: color.common.white. Alpha Value: 15% */
    'quaternary': 'rgba(241, 241, 241, 0.05)', /* Reference Token: color.common.white. Alpha Value: 5% */
    'background': '#020a19', /* Reference Token: color.blue.300
 */
  },
  'labels': {
    'primary': 'rgba(241, 241, 241, 0.85)', /* Reference Token: color.common.white. Alpha Value: 85% */
    'secondary': 'rgba(241, 241, 241, 0.7)', /* Reference Token: color.common.white. Alpha Value: 70% */
  },
  'semantic': {
    'live': 'rgba(225, 19, 65, 0.94)', /* Reference Token: color.red.200. Alpha Value: 94% */
    'alert-red': '#c25454', /* Reference Token: color.red.50 */
    'a11y-venu-orange': '#ff7233', /* Reference Token: color.orange.200 */
    'venu-blue': '#23395f',
    'venu-blue-accent': '#364154',
    'alert-green': '#4bcb34', /* Reference Token: color.green.200 */
  },
  'scrims': {
    '50': 'rgba(0, 0, 0, 0.5)', /* Reference Token: color.common.black. Alpha Value: 50% */
    'jump-gradient': 'linear-gradient(301deg, #151B26 49.5%, #525763 97.89%)',
    'player-background': 'linear-gradient(180deg, #00000000 0%, #00000000 36.14%, #000000 100%)', /* Reference Token: color.common.black alpha values */
    'half-dimmer': 'linear-gradient(180deg, #00000000 50%, #00000080 100%)', /* Reference Token: color.common.black alpha values */
    'full-dimmer': 'linear-gradient(180deg, #00000000 0%, #000000cc 100%)', /* Reference Token: color.common.black alpha values */
  },
};
